/**
 *
 * @module advertisingIdProvider
 *
 */

/**
 *
 * @class AdvertisingIdProvider
 * @since 3.6.0
 *
 */
export default class AdvertisingIdProvider {

    constructor() {

        /**
         *
         * @access private
         * @type {String}
         * @desc hardcoded to this value since JS SDK platforms do not support advertisingId's
         * @see https://wiki.bamtechmedia.com/pages/viewpage.action?pageId=61506803
         *
         */
        this.devId = '00000000-0000-0000-0000-00000000000';

        /**
         *
         * @access private
         * @type {Boolean}
         * @desc will indcate if a user has enabled or disabled tracking on their device
         * @note will always be false (meaning they have not disabled tracking) for JS platforms
         * @note we use _limitTracking because we want to match the spec and keep this private property while providing
         * the limitTracking method on the instance
         *
         */
        this._limitTracking = false;

    }

    /** #region private */

    /**
     *
     * @access private
     * @returns {String}
     * @desc will return a device's advertisingId if tracking is enabled
     * @note currently no JS platforms support limitTracking so we return the default devId
     * @note some platforms may override this method to interact with a system API
     *
     */
    getId() {

        const { devId } = this;

        return this.limitTracking() ? devId : devId;

    }

    /**
     *
     * @access private
     * @returns {Boolean}
     * @note meant to interact with a system API to determine if a user has disabled tracking - currently not supported
     * on any JS platforms
     * @note some platforms may override this method to interact with a system API
     *
     */
    limitTracking() {

        return this._limitTracking;

    }

}



// WEBPACK FOOTER //
// ./src/media/adEngine/advertisingIdProvider.js